import { useEffect, useState } from 'react';
import { useMapContext } from '@uiw/react-baidu-map-map';
import { useVisiable } from '@uiw/react-baidu-map-utils';
export function usePanoramaControl(props) {
  if (props === void 0) {
    props = {};
  }
  var [panoramaControl, setPanoramaControl] = useState();
  var {
    map
  } = useMapContext();
  useEffect(() => {
    if (map && !panoramaControl) {
      var instance = new BMap.PanoramaControl();
      map.addControl(instance);
      setPanoramaControl(instance);
      return () => {
        map.removeControl(instance);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);
  useVisiable(panoramaControl, props);
  return {
    panoramaControl,
    setPanoramaControl
  };
}